import type { ReactElement } from 'react'
import { ImgGlyph } from './ImgGlyph'
import type { GlyphProps } from './shared'

export const Goldfish = ({ size = 110 }: GlyphProps): ReactElement => (
  <ImgGlyph src="/glyph-assets/goldfish-1.png" size={size} alt="goldfish" />
)
